export const QA_NAME_GRETA_AI_CHAT_MARKDOWN_LINK = 'gretaAIChatMarkdownLink'
